import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="search--filters"
export default class extends Controller {
  static targets = [
    "boundsInput",
    "byAgeGroupsInput",
    "availableAtStartTimeInput",
    "availableAtEndTimeInput",
    "bookableOnDateInput",
    "form",
    "loading",
    "providerName",
    "resultsCount",
    "filtersCount",
    "selectedDate",
    "zoomInput",
  ];

  reset() {
    const checkboxes = this.element.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach((checkbox) => {
      checkbox.checked = false;
    });
    this.availableAtStartTimeInputTarget.value = "";
    this.availableAtEndTimeInputTarget.value = "";
    this.providerNameTarget.value = "";
    this.boundsInputTarget.value = "";
    this.bookableOnDateInputTarget.value = "";
    this.zoomInputTarget.value = "";
    for (const input of this.byAgeGroupsInputTargets) {
      input.checked = false;
    }
    this.dispatch("filters:reset");
  }

  submit(_event) {
    this.formTarget.requestSubmit();
  }

  onResultsCountChanged(event) {
    if (this.hasResultsCountTarget) {
      this.resultsCountTarget.textContent = event.detail.count;
    }
  }

  updateFiltersCount() {
    let count = 0;

    if (this.byAgeGroupsInputTargets.some((input) => input.checked)) {
      count++;
    }

    if (this.availableAtStartTimeInputTarget.value) {
      count++;
    }

    if (this.availableAtEndTimeInputTarget.value) {
      count++;
    }

    if (this.bookableOnDateInputTarget.value) {
      count++;
    }

    if (this.providerNameTarget.value) {
      count++;
    }

    this.filtersCountTarget.textContent = count;
  }
}
